<template>
	<v-container>
		<v-row justify="space-between">
			<v-col cols="12" md="12">
				<title-text>Wallet.</title-text>
			</v-col>
			<v-col cols="12" md="6" lg="6" xl="5">
				<v-card
					class="wallet-card rounded-lg py-4"
					color="primary"
					flat
					style="position: relative"
					min-height="240"
				>
					<v-img
						contain
						height="240"
						:src="require('../../assets/wallet-patterns.png')"
						style="position: absolute"
					/>
					<homify-icon class="mx-5" style="transform: scale(0.8)" />
					<div class="px-8 pt-3 white--text z-index-1">
						<div class="d-flex justify-left mb-2">
							<img height="30" :src="require('../../assets/card-seal.png')" />
						</div>
						<div class="text-h6 font-weight-regular">Wallet Balance</div>
						<div class="font-weight-bold text-h4" v-if="!isFetchingBalance">
							{{ formattedBalance }}
						</div>
						<v-progress-circular
							v-else
							indeterminate
							color="secondary"
						></v-progress-circular>
						<div>
							<div class="text-caption mt-3">HOMIFY ACCOUNT</div>
						</div>
						<v-chip x-small color="secondary">
							<div class="text-caption">COMING SOON</div>
						</v-chip>
						<div v-if="false" class="d-flex justify-space-between align-end">
							<div class="d-flex align-center">
								<div
									class="font-weight-bold text-h6"
									style="letter-spacing: 2em"
								>
									1029345383
								</div>
								<hm-icon class="ml-2">
									<copy-icon></copy-icon>
								</hm-icon>
							</div>
							<div
								class="font-weight-regular text-body-1"
								style="letter-spacing: 2px"
							>
								Wema Bank
							</div>
						</div>
					</div>
				</v-card>
			</v-col>

			<v-col cols="12" md="6" lg="6">
				<div class="font-weight-medium text-h6">Actions</div>
				<v-row justify="space-between">
					<v-col cols="12" md="4" v-for="(action, i) in actions" :key="i">
						<action-card :action="action" />
					</v-col>
				</v-row>
			</v-col>
			<v-col cols="12" md="6" class="mt-8">
				<div class="d-flex align-center justify-space-between">
					<div class="font-weight-medium text-h6">Bank Accounts</div>
					<v-card
						v-if="bankAccounts.length > 0"
						height="20"
						width="20"
						class="rounded-circle pa-1 d-flex align-center justify-center"
						flat
						color="secondary"
						@click="addBankDialog = true"
					>
						<v-icon color="primary" size="15">mdi-plus</v-icon>
					</v-card>
				</div>

				<v-card
					flat
					class="bank-wrapper rounded-lg primary--border pa-3"
					color="#FFF9F2"
					height="200"
					max-height="200"
					width="100%"
				>
					<div
						class="d-flex justify-center align-center fill-height"
						v-if="bankAccounts.length == 0 && !isLoadingAccounts"
					>
						<div class="z-index-1 text-center" @click="addBankDialog = true">
							<v-btn icon color="transparent">
								<hm-icon height="43" width="47">
									<plus-circle-icon />
								</hm-icon>
							</v-btn>
							<div class="text-h6 black--text font-weight-regular mt-1">
								Add Bank Account
							</div>
						</div>
					</div>
					<div
						class="d-flex justify-center align-center fill-height"
						v-if="isLoadingAccounts"
					>
						<v-progress-circular
							:size="50"
							:width="5"
							color="secondary"
							indeterminate
						></v-progress-circular>
					</div>
					<div v-if="bankAccounts.length > 0 && !isLoadingAccounts">
						<v-row>
							<v-col
								cols="12"
								md="12"
								lg="12"
								xl="6"
								v-for="(bankAccount, idx) in bankAccounts"
								:key="idx"
							>
								<v-card class="hm-elevation__soft rounded-lg pa-3" flat>
									<div class="d-flex justify-end mb-1">
										<!-- <div class="font-weight-medium">Account Details</div> -->
										<v-menu bottom left>
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													style="position: absolute; top: 10; right: 10"
													icon
													x-small
													v-bind="attrs"
													v-on="on"
												>
													<v-icon>mdi-dots-vertical</v-icon>
												</v-btn>
											</template>

											<v-list>
												<v-list-item
													@click="item.action(bankAccount.id)"
													v-for="(item, i) in bankActions"
													:key="i"
												>
													<v-list-item-title>{{
														item.title
													}}</v-list-item-title>
												</v-list-item>
											</v-list>
										</v-menu>
									</div>
									<div class="d-flex pt-3">
										<!-- <img width="40" height="30" :src="require('../../assets/icons/bank-logos/access_bank.svg')" /> -->
										<div class="">
											<div>
												<span class="font-weight-medium">Name of Bank:</span>
												{{ bankAccount.accountname }}
											</div>
											<div>
												<span class="font-weight-medium">Account Number:</span>
												{{ bankAccount.accountnumber }}
											</div>
										</div>
									</div>
								</v-card>
							</v-col>
						</v-row>
					</div>
				</v-card>
			</v-col>
			<v-col cols="12" md="6" class="mt-8">
				<div class="d-flex align-center justify-space-between">
					<div class="font-weight-medium text-h6">Debit Cards</div>
					<v-card
						v-if="debitCards.length > 0 && !isLoadingCards"
						height="20"
						width="20"
						class="rounded-circle pa-1 d-flex align-center justify-center"
						flat
						color="secondary"
						@click="addBankDialog = true"
					>
						<v-icon color="primary" size="15">mdi-plus</v-icon>
					</v-card>
				</div>

				<v-card
					flat
					:color="
						debitCards.length == 0 && !isLoadingCards
							? '#FFF9F2'
							: 'transparent'
					"
					height="200"
					max-height="200"
				>
					<div
						class="d-flex justify-center align-center fill-height"
						:class="{
							'bank-wrapper rounded-lg primary--border pa-3':
								debitCards.length == 0,
						}"
						v-if="debitCards.length == 0 && !isLoadingCards"
					>
						<v-chip color="secondary">COMING SOON</v-chip>
					</div>
					<div
						class="d-flex justify-center align-center fill-height"
						v-if="isLoadingCards"
					>
						<v-progress-circular
							:size="50"
							:width="5"
							color="secondary"
							indeterminate
						></v-progress-circular>
					</div>
					<div v-if="debitCards.length > 0 && !isLoadingCards" class="">
						<div class="d-flex overflow-x-auto">
							<v-card
								class="wallet-card mr-2 rounded-lg"
								color="primary"
								flat
								style="position: relative"
								height="200"
								min-height="200"
								width="45vw"
								min-width="330"
								v-for="(debitCard, idx) in debitCards"
								:key="idx"
							>
								<v-img
									contain
									height="240"
									:src="require('../../assets/wallet-patterns.png')"
									style="position: absolute"
								/>
								<homify-icon class="mx-5 mt-4" style="transform: scale(0.8)" />
								<div class="px-8 white--text z-index-1">
									<div class="d-flex justify-left mt-2">
										<img
											height="25"
											:src="require('../../assets/card-seal.png')"
										/>
									</div>
									<div
										class="font-weight-medium mt-4"
										v-if="!isFetchingBalance"
										style="font-size: 1.2rem; letter-spacing: 2.5px"
									>
										XXXX XXXX XXXX {{ 5045 }}
									</div>
									<div class="d-flex mt-3">
										<div class="mr-2">
											<div style="font-size: 0.6rem">VALID</div>
											<div style="font-size: 0.6rem">THRU</div>
										</div>
										<div>12/24</div>
									</div>
									<div class="text-caption py-3 font-weight-medium">
										PETERS GIDEON OJOAJOGU
									</div>
								</div>
							</v-card>
						</div>
					</div>
				</v-card>
			</v-col>
			<v-col>
				<div
					class="d-flex justify-space-between mt-8"
					:class="{
						'flex-column align-start': $vuetify.breakpoint.mdAndDown,
					}"
				>
					<div class="text-h4 font-weight-bold primary--text">
						Recent Transactions
					</div>
					<v-btn
						@click="$router.push({ name: 'dashboard.transactions' })"
						depressed
						color="primary"
						class="py-6 text-none"
						>View All Transactions</v-btn
					>
				</div>
				<v-card flat class="mt-10 rounded-xl secondary--border overflow-y-auto">
					<v-data-table
						:headers="headers"
						:items="transactions"
						:items-per-page="5"
						:loading="isFetchingTransactions"
						hide-default-footer
					>
						<template v-slot:header.date="{ header }">
							<div
								class="py-6 px-5 text-body-1 font-weight-bold primary--text d-flex align-center"
							>
								<span class="mr-1">{{ header.text }}</span>
								<hm-icon height="18" width="30">
									<sort-icon />
								</hm-icon>
							</div>
						</template>
						<template v-slot:header.action="{ header }">
							<div class="py-6 text-body-1 font-weight-bold primary--text">
								{{ header.text }}
							</div>
						</template>
						<template v-slot:header.created_at="{ header }">
							<div class="py-6 text-body-1 font-weight-bold primary--text">
								{{ header.text }}
							</div>
						</template>
						<template v-slot:header.type="{ header }">
							<div class="py-6 text-body-1 font-weight-bold primary--text">
								{{ header.text }}
							</div>
						</template>
						<template v-slot:header.amount="{ header }">
							<div class="py-6 text-body-1 font-weight-bold primary--text">
								{{ header.text }}
							</div>
						</template>
						<template v-slot:item.createdat="{ item }">
							<div class="text-body-1">
								{{ formatDate(item.createdat) }}
							</div>
						</template>
						<template v-slot:item.description="{ item }">
							<div class="text-body-1">
								{{ item.description }}
							</div>
						</template>
						<template v-slot:item.transactiontype="{ item }">
							<div class="text-body-1 text-capitalize">
								{{ item.transactiontype }}
							</div>
						</template>
						<template v-slot:item.amount="{ item }">
							<div class="text-body-1 text-capitalize">
								{{ formatMoney(item.amount) }}
							</div>
						</template>
					</v-data-table>
				</v-card>
			</v-col>
		</v-row>
		<topup-dialog
			@completeTopup="getWalletBalance"
			:topUpDialog="topUpDialog"
			@toggleDialog="topUpDialog = $event"
		/>
		<withdraw-dialog
			:withdrawDialog="withdrawDialog"
			@toggleDialog="withdrawDialog = $event"
		/>
		<add-bank-account-dialog
			:addBankDialog="addBankDialog"
			@toggleDialog="addBankDialog = $event"
			@addBank="getBankAccounts"
		/>
		<delete-bank-account-dialog
			:deleteBankDialog="deleteBankDialog"
			@deletedBank="getBankAccounts"
			:id="selectedBankId"
			@toggleDialog="deleteBankDialog = $event"
		/>
		<add-debit-card-dialog
			:addDebitCardDialog="addDebitCardDialog"
			@toggleDialog="addDebitCardDialog = $event"
		/>
	</v-container>
</template>

<script>
	import TitleText from "@/components/dashboard/DbTitleText.vue";
	import HmIcon from "@/components/HmIcon.vue";
	import PlusCircleIcon from "@/components/icons/PlusCircleIcon.vue";
	import SortIcon from "@/components/icons/dashboard/SortIcon.vue";
	import {
		UserService,
		TransactionService,
		BankAccountService,
	} from "@/services/index.js";
	import { formatMoney, formatDate, bankLogo } from "@/utils/helpers";
	import pgUtilsMixin from "./../../mixins/pgUtilsMixin.js";
	import HomifyIcon from "@/assets/svg/homify-logo__mini.svg";
	import CopyIcon from "@/components/icons/CopyIcon.vue";
	import TopupDialog from "@/components/wallet/TopupDialog.vue";
	import WithdrawDialog from "@/components/wallet/WithdrawDialog.vue";
	import AddBankAccountDialog from "@/components/wallet/AddBankAccountDialog.vue";
	import DeleteBankAccountDialog from "@/components/wallet/DeleteBankAccountDialog.vue";
	import AddDebitCardDialog from "@/components/wallet/AddDebitCardDialog.vue";
	import ActionCard from "@/components/wallet/ActionCard.vue";

	export default {
		components: {
			TitleText,
			HmIcon,
			PlusCircleIcon,
			SortIcon,
			CopyIcon,
			HomifyIcon,
			TopupDialog,
			WithdrawDialog,
			AddBankAccountDialog,
			DeleteBankAccountDialog,
			ActionCard,
			AddDebitCardDialog,
		},
		data() {
			return {
				formatMoney,
				formatDate,
				walletBalance: 0,
				isFetchingBalance: false,
				isFetchingTransactions: false,
				isLoadingAccounts: false,
				isLoadingCards: false,
				topUpDialog: null,
				withdrawDialog: null,
				addBankDialog: null,
				deleteBankDialog: null,
				addDebitCardDialog: null,
				bankAccounts: [],
				debitCards: [],
				transactions: [],
				bankOptions: [],
				otp: "",
				selectedBankId: 0,
				actions: [
					{
						title: "Top Up",
						icon: "plus-circle-icon",
						action: () => {
							return (this.topUpDialog = true);
						},
					},
					{
						title: "Invest",
						icon: "plus-circle-icon",
						action: () => {
							return this.$router.push({ name: "dashboard.investments" });
						},
					},
					{
						title: "Withdraw",
						icon: "withdraw-icon",
						action: () => {
							return (this.withdrawDialog = true);
						},
					},
				],
				bankActions: [
					{
						title: "Delete Account",
						action: (id) => {
							return this.deleteAccount(id);
						},
					},
				],
				headers: [
					{
						text: "Date",
						align: "start",
						sortable: false,
						value: "createdat",
					},
					{ text: "Action Taken", value: "description", sortable: false },
					{ text: "Payment Type", value: "transactiontype", sortable: false },
					{ text: "Amount Paid", value: "amount", sortable: false },
				],
			};
		},
		mixins: [pgUtilsMixin],
		computed: {
			formattedBalance() {
				return formatMoney(this.walletBalance ?? 0);
			},
		},
		methods: {
			bankLogo,
			async getWalletBalance() {
				try {
					this.isFetchingBalance = true;
					const { data: wallet } = await UserService.getWallet();
					// divide by 100 because it came in kobo
					this.walletBalance = wallet.balance;
					this.isFetchingBalance = false;
				} catch (error) {
					this.isFetchingBalance = false;
				}
			},
			deleteAccount(id) {
				this.selectedBankId = id;
				this.deleteBankDialog = true;
			},
			async getBankAccounts() {
				try {
					this.isLoadingAccounts = true;
					const { data: accounts } = await BankAccountService.getAll();

					this.bankAccounts = accounts;
					this.isLoadingAccounts = false;
				} catch (error) {
					this.isLoadingAccounts = false;
				}
			},
			async getTransactions() {
				try {
					this.isFetchingTransactions = true;
					const {
						data: { data: transactions, lastPage, perPage, total },
					} = await TransactionService.getWalletTransactions(1);
					this.transactions = transactions;
					// console.log(transactions);
					// this.itemsPerPage = perPage;
					// this.lastPage = lastPage;
					// this.pageCount = total;
					// let res = await TransactionService.getWalletTransactions();

					// this.transactions = res.data?.transactions;
					this.isFetchingTransactions = false;
				} catch (error) {
					this.isFetchingTransactions = false;
				}
			},
			async getDebitCards() {
				try {
					this.isLoadingCards = true;

					const {
						data: { cards },
					} = await UserService.getCards();
					this.debitCards = cards;
					this.isLoadingCards = false;
				} catch (error) {
					this.isLoadingCards = false;
				}
			},
			openDialogWhenMounted() {
				if (this.$route.query.topup) {
					this.topUpDialog = true;
				}
			},
		},
		mounted() {
			this.getWalletBalance();
			this.openDialogWhenMounted();
			this.getTransactions();
			this.getBankAccounts();
		},
		watch: {
			deleteBankDialog(v) {
				if (!v) {
					this.selectedBankId = 0;
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.theme--light.v-data-table tbody tr:nth-of-type(odd) {
		background-color: #fff9f2;
		border: 5px solid blue !important;
		border-top: none !important;
		border-bottom: none !important;
	}
	.theme--dark.v-data-table tbody tr:nth-of-type(odd) {
		background-color: #fff9f2;
		border: 5px solid blue !important;
		border-bottom: none !important;
		border-top: none !important;
	}

	.wallet-card {
		position: relative;
		width: 100%;
		background: black;
		overflow: hidden;
	}

	.bank-wrapper {
		box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.06),
			0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04) !important;
	}

	.z-index-1 {
		z-index: 9;
	}
</style>
